var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"text-container"},[_c('p',{staticClass:"black--text mb-1"},[_vm._v(_vm._s(_vm.text))]),(_vm.showprogress)?_c('v-progress-linear',{attrs:{"color":"primary","indeterminate":""}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }